// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import SheetContainer, { Content, Overlay, Sheet } from '../../mobile/structural/sheet';
import BillingTierFree from '../../workspace/header/workspaceToolsHeader/account/billingStatus/BillingTierFree';

// Selectors
import { getCurrentUser } from '../../user/currentUserSelector';

// Utils
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';

// Types
import { SheetId } from '../structural/sheet/sheetTypes';

import './BillingAlertSheet.scss';

const BillingAlertSheet = () => {
    const sheetProps = useSheet(SheetId.BillingAlertPopup);

    const { dispatchCloseSheet } = sheetProps;

    const currentUser = useSelector(getCurrentUser);

    return (
        <SheetContainer {...sheetProps} className="BillingAlertSheet">
            <Overlay />
            <Sheet>
                <Content>
                    <BillingTierFree currentUser={currentUser} onUpgradeClick={dispatchCloseSheet} />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default BillingAlertSheet;
